import {Component, Input, OnInit} from '@angular/core';

@Component({
   selector: 'app-alert',
   templateUrl: './alert.component.html',
   styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
   @Input() message: string | null = ""
   @Input() htmlMessage: string | null = ""
   @Input() mode: "danger" | "success" | 'warning' | 'info' = "info"
   @Input() title: string = ""
   @Input() list: any[] = []


   constructor() {

      console.log(this.mode)


   }

   ngOnInit(): void {
   }

}
